





















































import Vue, { VueConstructor } from "vue";
import VaButton from "@/components/atoms/VaButton.vue";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import cloneDeep from "lodash/clone";
import { WizardConfiguration } from "@/models/wizardConfiguration";
import VaTextField from "@/components/atoms/VaTextField.vue";
import validationMixin from "@/components/mixins/validationMixin";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "StepCredentials",
  mixins: [wizardStepsMixin, validationMixin],
  data() {
    return {
      userName: "Mago" as string | undefined,
      password: "" as string | undefined,
    };
  },
  components: { VaTextField, VaButton },
  computed: {},
  methods: {
    onFinish() {
      if (this.userName) {
        const res = this.wizardConfiguration
          ? cloneDeep(this.wizardConfiguration)
          : ({} as WizardConfiguration);
        res.userName = this.userName;
        res.password = this.password;
        this.$emit("onUpdateConfig", res);
        this.onNext();
      }
    },
  },
});
